define('plugin/additional-fields/collection/AdditionalFieldsCollection',['require','lib/collection/BaseCollection','plugin/additional-fields/model/AdditionalFieldModel'],function (require) {

    var BaseCollection = require('lib/collection/BaseCollection');
    var AdditionalFieldModel = require('plugin/additional-fields/model/AdditionalFieldModel');

    /**
     * Additional fields collection
     *
     * @class AdditionalFieldsCollection
     */
    return BaseCollection.extend({

        url: '/ext/additional-fields/',
        model: AdditionalFieldModel,

        initialize: function () {
            BaseCollection.prototype.initialize.apply(this, arguments);

            this.listenTo(this, 'sync', this.initDefaultValues);
        },

        initDefaultValues: function () {
            this.each(function (model) {
                if (!model.get('value') && model.getDefault()) {
                    model.set('value', model.getDefault());
                }
            });

            this.setDataFromLastValue();
        },

        removeValues : function(){
            this.each(function (model) {
                if (model.get('value') && model.getDefault()) {
                    model.set('value', model.getDefault());
                } else if (model.get('value')){
                    model.set('value', null);
                }
            });
        },

        setDataFromLastValue: function () {
            this.each(function (model) {
                if (model.get('last_value')) {
                    model.set('value', model.get('last_value'));
                }
            });
        }

    });

});
